import React from "react";

import withSessionHandling, {
  type SessionHandlerProps,
} from "@/context/auth/withSessionHandling";
import { useRouterSearchParams } from "@/hooks/router";
import FollowingsScreen from "@/screens/Relationships/FollowingsScreen";

function Page(props: SessionHandlerProps): React.JSX.Element {
  const username = useRouterSearchParams("username");
  return <FollowingsScreen {...props} username={username} />;
}

export default withSessionHandling(Page);
